import React, { Fragment, memo } from "react";
import { Listbox, Transition } from "@headlessui/react";

import { icons } from "constants/icons";
import { Option } from "types/common";

type Props = {
  options: Option[];
  selectedOption: Option;
  onChange: (value: Option) => void;
};

export const Select = memo(({ options, selectedOption, onChange }: Props) => {
  return (
    <div className="w-full">
      <Listbox value={selectedOption} onChange={onChange}>
        <div className="relative">
          <Listbox.Button className="relative w-full py-1.5 pl-[11px] pr-5 text-left bg-white rounded-lg card focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm">
            <span className="block truncate text-grayDark text-sm">
              {selectedOption?.label}
            </span>
            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <img src={icons.carrotDown} alt="arrow" />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md  max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-[2]">
              {options.map((option) => (
                <Listbox.Option
                  key={option?.value}
                  className={({ active }) =>
                    `${active ? "text-amber-900 bg-amber-100" : "text-grayDark"}
                          cursor-default select-none relative py-2 px-4`
                  }
                  value={option?.value}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`${
                          selected ? "font-bold" : "font-normal"
                        } block truncate text-sm`}
                      >
                        {option?.label}
                      </span>
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
});
